export default "__VITE_ASSET__3771a912__"